import amplitude from './amplitude';

export const track = (event, payload, isSpaApp) => {
    try {
        if (isSpaApp) {
            amplitude.keap.logEvent(event, payload);
        } else {
            amplitude.infusionsoft.track(event, payload);
        }
    } catch {
        // do nothing
    }
};

export const setUserProperties = (payload, isSpaApp) => {
    try {
        if (isSpaApp) {
            amplitude.keap.setUserProperties(payload);
        } else {
            amplitude.infusionsoft.setUserProperties(payload);
        }
    } catch {
        // do nothing
    }
};
